import * as React from 'react';
import { ToneDto } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ListViewModelImpl } from '../../../../toolkit/horizontallist/listviewmodel';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { ToneRowOptionsPrivilage } from '../../../../toolkit/toneoptions/tone/tonerowcomponent';
import { SearchListToneCardPlayerCSSStyleImpl } from '../../searchlist/searchlisttonecardplayercss';
import { FeaturedToneRowOptionsImpl } from '../viewmodel/featuredcategorylistviewmodel';
import { ToneCardComponent } from '../viewmodel/tonecard/tonecardcomponent';
import { ToneCardCSSStyle, ToneCardCSSStyleImpl } from '../viewmodel/tonecard/tonecardcssstyle';
import { ToneCardPlayerCSSStyleImpl } from '../viewmodel/tonecard/tonecardplayercss';
import { ToneEvenCardCSSStyleImpl } from '../viewmodel/tonecard/toneevencardcssstyle';
import { ToneMobileCardPlayerCSSStyleImpl } from '../viewmodel/tonecard/tonemobilecardplayercss';


export class ShowMoreFeaturedCategoryToneViewModelImpl extends ListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    private privilage: ToneRowOptionsPrivilage;
     private audioPlayerWithProgress: AudioPlayerWithProgress;
    private playerCSSStyle: SearchListToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle: ToneCardPlayerCSSStyleImpl;
  
    constructor(context: BaseContext, private marginTop: string, title: string)
    {
        super(context);
        this.onToneSelected = this.onToneSelected.bind(this);
        
        this.toneOddCardCSSStyle = new ToneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new ToneEvenCardCSSStyleImpl(context);
        this.privilage = new FeaturedToneRowOptionsImpl();
        this.playerCSSStyle = new SearchListToneCardPlayerCSSStyleImpl(context);
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(context.getPlayerManager().getAudioPlayer());

        this.playerMobileCSSStyle = new ToneMobileCardPlayerCSSStyleImpl(context);
    }

    // setTitle(title: string)
    // {
    //     this.title = title;
    // }

    getOffset(): number
    {
        return 5;
    }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} isPlayInitial={position === 0} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.privilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneOddCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <ToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle} isPlayInitial={position === 0} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.privilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneEvenCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

    protected onToneSelected(): void
    {
       
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/showmorefeaturedcategory/showmorefeaturedcategoryviewmodel.tsx